import React from 'react';
import {
  Link,
} from "react-router-dom";

import { HashLink } from 'react-router-hash-link';

function FooterView() {
    return (
        <div className={'footer-container'}>
             <img 
                src={require("../../assets/logo.png")} 
                className={'main-logo footer'}
            />

            <div className={'footer-links-container'}>
                <Link to="/privacy-policy" className={'footer-link'}>
                    Privacy Policy
                </Link>
                <Link to="/terms-of-use" className={'footer-link'}>
                    Terms Of Use
                </Link>
                <Link to="/contact-us" className={'footer-link'}>
                    Contact
                </Link>
                <a className={'footer-link'}>
                    About Us
                </a>
                <a className={'footer-link'}>
                    Preferences
                </a>
                <HashLink to="/privacy-policy#do-not-sell" className={'footer-link'}>
                    Do Not Sell My Personal Information
                </HashLink>
            </div>
        </div>
    );
}

export default FooterView;
